import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tools--form"
export default class extends Controller {
  static targets = ["form"]

  connect() {
  }

  new() {
    document.querySelectorAll("#toolsTable tbody tr.selected")
      .forEach(e => e.classList.remove("selected"))
  }

  save() {
    this.formTarget
      .querySelectorAll("input[name='_method'][value='delete']")
      .forEach(e => e.remove())
  }
}
